<template>
  <div id="round-receive-setting" class="container">
    <div class="page-header mb-1">
      <strong>ตั้งค่ารับของเฉพาะงวด</strong>
    </div>

    <div v-if="roundId" class="card">
      <div class="card-header">
        <h5 class="card-title mb-0">
          <i class="fas fa-exclamation-triangle text-danger mr-2"></i>
          <span class="text-dark mr-2">เฉพาะงวด</span>
          <span class="text-primary mr-2">{{ roundName }}</span>
          <span class="text-dark mr-2">วันที่</span>
          <span class="text-primary mr-2">{{ roundDate }}</span>
          <small class="text-secondary">(เปลี่ยนได้ที่แถบเมนูด้านบน)</small>
        </h5>
      </div>
      <div class="card-body">
        <RoundCloseTime :data="data" class="mb-4" @reload="loadRoundData" />
        <RoundReceiveTable :data="data" class="mb-5" @reload="loadRoundData" />
        <RoundReceiveNumbers :data="data" class="mb-4" @reload="loadRoundData" />
      </div>
    </div>
    <div v-else class="card">
      <div class="card-body">กรุณาเลือกงวดหวย</div>
    </div>
  </div>
</template>
<script>
import RoundService from "@/services/RoundService"

import Swal from 'sweetalert2'
import moment from '@/helpers/moment'
import cAlert from '@/helpers/alert'

import RoundCloseTime from './components/RoundCloseTime'
import RoundReceiveTable from './components/RoundReceiveTable'
import RoundReceiveNumbers from './components/RoundReceiveNumbers'

export default {
  name: 'RoundReceive',
  components: {
    RoundCloseTime,
    RoundReceiveTable,
    RoundReceiveNumbers
  },
  data() {
    return {
      data: null,
      isProcess: false
    }
  },
  computed: {
    marketType() {
      return this.data?.market?.marketType
    },
    isSingle() {
      return this.marketType === 'single'
    },
    roundId() {
      return this.$store.state.globalMarket?.round?.roundId
    },
    roundName() {
      if(!this.data)
        return ''

      return `[${this.data.round.note.groupTitle}] ${this.data.round.note.marketTitle}`
    },
    roundDate() {
      if(!this.data)
        return ''

      return moment(this.data.round.roundDate.date).format("DD/MM/YYYY")
    }
  },
  watch: {
    roundId() {
      this.loadRoundData()
    }
  },
  methods: {
    loadRoundData() {
      if(!this.roundId)
        return

      RoundService.getRoundSetting(this.roundId)
      .then((response)=>{
        if(response.success) {
          this.data = response.data

          if(response?.data?.market?.marketType === 'lottoset') {
            this.$router.push({name: 'LottosetSetting'})
          }
        }else{
          throw new Error(response.data)
        }
      })
      .catch((e)=>{
        cAlert({
          ...e,
          title: 'ผิดพลาด!',
          text: e?.message || 'โหลดข้อมูลไม่สำเร็จ กรุณาลองใหม่อีกครั้ง',
          icon: 'error',
          confirmButtonText: 'OK'
        })
      })
      .finally(()=>{
        this.isProcess = false
      })
    }
  },
  mounted() {
    this.loadRoundData()
  }
}
</script>
<style lang="scss" scoped>
#round-receive-setting {
}
</style>
